import { styles } from './ShowMoreButton.styles';

export interface ShowMoreButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  children: React.ReactNode;
}

export function ShowMoreButton({
  onClick,
  isLoading,
  children
}: ShowMoreButtonProps) {
  const slots = styles({ isLoading });

  return (
    <button
      onClick={onClick}
      type="button"
      className={slots.base({
        isLoading
      })}
    >
      <span className={slots.loading()} />
      <span className={slots.loadMoreButtonText()}>{children}</span>
    </button>
  );
}
